export default {
    tabListContainer: { mx: 1 },
    tabContentContainer: { borderBottom: 1, borderColor: "divider" },
    tabPanelList: {
        "&  .MuiDataGrid-root": { height: "75vh" }
    },
    mainHeaderContainer: {
        mx: 2,
        my: 4,
        "& h6": {
            verticalAlign: "middle"
        },
        "& > *": { display: "inline-block" }
    }
};
